import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export type NormalizedHttpError = {
    status?: number;          // HTTP status code (e.g., 401, 500)
    message: string;          // human-friendly message
    isNetworkError: boolean;  // true if no response from server
    code?: string;            // axios/browser error code, if any
    data?: unknown;           // raw server body (useful for field errors, etc.)
  };
  type UiState = {
    pendingCount: number;                       // number of in-flight requests
    lastError: NormalizedHttpError | null;      // latest error for global toast/dialog
  };
  const initialState: UiState = {
    pendingCount: 0,
    lastError: null,
  };

  const uiSlice = createSlice({
    name: "ui",
    initialState,
    reducers: {
      incPending(state) {
        state.pendingCount += 1;
      },
      decPending(state) {
        state.pendingCount = Math.max(0, state.pendingCount - 1);
      },
      setGlobalError(state, action: PayloadAction<NormalizedHttpError | null>) {
        state.lastError = action.payload;
      },
      clearGlobalError(state) {
        state.lastError = null;
      },
    },
  });

  export const {
    incPending,
    decPending,
    setGlobalError,
    clearGlobalError,
  } = uiSlice.actions;
  
  export const uiSliceReducer = uiSlice.reducer;